import { InterventionPreventive } from '@/models/InterventionPreventive';
import { SortType } from '@/models/SortType';
import { TableHeader } from '@/models/TableHeader';
import dayjs from 'dayjs';
import { InterventionNonPreventive } from '@/models/InterventionNonPreventive';

export interface EquipementInterventionsState {
    interventions: InterventionPreventive[];
    interventionsNonPreventives?: InterventionNonPreventive[];

    equipementId: string[];

    active: boolean;

    tableHeader: TableHeader[];

    page: number;
    nbOfPages: number;
    scroll: number;
    count: number;

    sort?: {
        sortData: string;
        sortStatus: SortType;
    };

    filterDateDebut: string;
    filterDateFin: string;

    isLoading: boolean;
    error?: Error;
    success: boolean;
}

export const initialState: EquipementInterventionsState = {
    interventions: [],

    equipementId: [],

    active: false,

    tableHeader: [
        {
            label: 'label.numIntervention',
            sortData: 'id',
            sortStatus: SortType.NONE,
            width: '10%',
        },
        {
            label: 'label.type',
            sortData: 'typeIntervention',
            sortStatus: SortType.INACTIVE,
            width: '30%',
        },
        {
            label: 'label.periodicite',
            sortData: 'periodicite',
            sortStatus: SortType.NONE,
            width: '10%',
        },
        {
            label: 'intervention.dateDebutPrevue',
            sortData: 'dateDebutPrevue',
            sortStatus: SortType.DESC,
            width: '15%',
        },
        {
            label: 'dataList.dateRealise',
            sortData: 'dateDebutReelle',
            sortStatus: SortType.NONE,
            width: '15%',
        },
        {
            label: 'label.state',
            sortData: 'etat',
            sortStatus: SortType.NONE,
            width: '10%',
        },
        {
            label: 'dataList.interventionReport',
            sortData: 'isRapportPresent',
            sortStatus: SortType.INACTIVE,
            width: '10%',
        },
    ],

    page: 0,
    nbOfPages: 0,
    scroll: 0,
    count: 0,
    filterDateDebut: dayjs().subtract(6, 'month').startOf('month').format('YYYY-MM-DD'),
    filterDateFin: dayjs().add(6, 'month').startOf('month').format('YYYY-MM-DD'),

    isLoading: false,
    success: false,
};

const state = {
    ...initialState,
};

export default state;
